export default "__VITE_ASSET__BG_bRThR__"